<template>
  <el-cascader
    :options="cateList"
    :props="{ expandTrigger: 'hover' }"
    size="mini"
    :show-all-levels="false"
    v-model="cateValue"
    @change="cascaderChange"
    filterable
  >
    <template slot-scope="{ node, data }">
      <span>{{ data.label }}</span>
      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
    </template>
  </el-cascader>
</template>
<script>
export default {
  name: 'CateCascader',
  data() {
    return {
      cateList: [],
      cateValue: [],
    }
  },
  mounted() {
    this.getCate()
  },
  methods: {
    // 获取类别
    async getCate() {
      var newParamData = {
        schoolId: this.$store.state.schoolId,
      }
      let res = await this.$Http.getResourceClassification(newParamData, true)
      if (res.code == 200) {
        if (res.data.length > 0) {
          let data = res.data
          this.cateList = data.map((item) => {
            let obj = {}
            obj.value = item.id
            obj.label = item.fatherNode
            obj.level = 1
            if (
              item.resourceClassificationLists &&
              item.resourceClassificationLists.length > 0
            ) {
              obj.children = item.resourceClassificationLists.map((iitem) => {
                let objc = {}
                objc.value = iitem.id
                objc.label = iitem.subclassificationName
                objc.level = 2
                return objc
              })
            }
            return obj
          })
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: 'error',
          message: res.messsage,
        })
      }
    },
    cascaderChange(val) {
      // console.log(val, '-------当前选中了')
      
    },
  },
}
</script>
